<template>
    <div class="presellStep">
        <div class="up">
            <div class="title">阶段信息</div>
            <div class="step">
                <van-steps direction="vertical" active-color="#FF7A45" inactive-color='#cccccc' active-icon='' :active="active">
                    <van-step v-for="(item, index) in stepInfo" :key="index">
                        <h3 :class="{'colccc': !item.downColor }">{{item.title}}</h3>
                        <p class="col999" :class="{'colFF7A45': item.contentColor}">{{item.content}}</p>
                    </van-step>
                </van-steps>
            </div>
        </div>
        <div class="down" v-if="downShow">
            <van-checkbox checked-color='#FF7A45' label-disabled v-model="checked" @change="onChecked" shape="square">我同意<span @click="onHref">《平台预售业务规则》</span></van-checkbox>
        </div>
        <van-popup
            v-model="popupStep"
            position="right"
            :duration='0'
            :overlay='false'
            :close-on-click-overlay='true'
        >
            <div class="popup">
                <StepServer @onBack='onHref' />
            </div>
        </van-popup>
    </div>
</template>

<script>
import StepServer from '../server/presellServer'
export default {
    components: {
        StepServer
    },
    data () {
        return {
            checked: true,
            popupStep: false
        }
    },
    props: {
        // 是否底部的协议，默认隐藏
        downShow: {
            type: Boolean,
            default: false
        },
        // 当前步骤
        active: {
            type: Number,
            default: 0
        },
        // 步骤信息（注：downColor：步骤2的颜色显示，contentColor: =内容的显示）
        stepInfo: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    methods: {
        onHref () {
            this.popupStep = !this.popupStep
        },
        onChecked () {
            this.$emit('onChecked', this.checked)
        }
    }
}
</script>

<style lang="scss" scoped>
.presellStep {
    background: #ffffff;
    font-size: 32px;
    padding: 32px;
    .up{
        display: flex;
        justify-self: start;
        .title{
            margin-right: 48px;
        }
        h3{
            font-size: 32px;
            margin-bottom: 8px;
            color: #333333;
            &.colccc{
                color: #cccccc;
            }
        }
        p{
            font-size: 24px;
            &.col999{
                color: #999999;
            }
            &.colFF7A45{
                color: rgb(255, 122, 69) !important;
            }
        }
    }
}
.step{
    /deep/ .van-step{
        color: #cccccc;
    }
    /deep/ .van-step--finish{
        color: rgb(255, 122, 69);
        /deep/ .van-step__circle, /deep/ .van-step__line{
            background: rgb(255, 122, 69) !important;
        }
    }
    /deep/ .van-step--vertical{
        line-height: inherit;
        padding: 0 18px 48px 18px;
        &:last-child {
            padding-bottom: 0;
        }
    }
    /deep/ .van-step--vertical:not(:last-child)::after{
        border-bottom-width: 0px;
    }
    /deep/ .van-step__circle{
        width: 12px;
        height: 12px;
        background-color: #cccccc
    }
    /deep/ .van-icon{
        width: 12px;
        height: 12px;
        border-radius: 12px;
        background: rgb(255, 122, 69);
    }
}
.down{
    font-size: 26px;
    color: #8E8E93;
    padding-left: 180px;
    margin-top: 48px;
    span{
        color: #3399FF;
    }
    /deep/ .van-checkbox__label{
        line-height: inherit;
    }
    /deep/ .van-checkbox__icon {
        font-size: 26px;
        height: auto;
        line-height: inherit;
    }
    /deep/ .van-checkbox__icon .van-icon{
        font-size: 28px;
        width: auto;
        height: auto;
        line-height: inherit;
    }
    /deep/ .van-checkbox__label{
        margin-left: 16px;
    }
}
/deep/ .van-step--vertical .van-step__line {
    width: 2px;
}
/deep/ .van-step:last-child .van-step__line {
    width: 0;
}
/deep/ .popup {
    background: #ffffff;
    height: 100%;
    position: relative;
}
</style>